export const DEFAULT_FORM = [
  {
    iconL: 'user',
    name: 'document',
    placeholder: 'Documento',
    required: true,
    inputMode: 'numeric',
    autoComplete: 'username',
  },
  {
    iconL: 'edit',
    name: 'password',
    type: 'password',
    placeholder: 'Contraseña',
    required: true,
    autoComplete: 'current-password',
  },
]

export const RESET_FORM = [
  {
    iconL: 'user',
    name: 'document',
    placeholder: 'documento',
    required: true,
    inputMode: 'numeric',
    autoComplete: 'username',
  },
]

export const SIGNUP_FORM = () => [
  {
    iconL: 'edit',
    name: 'firstname',
    placeholder: 'Nombre',
    required: true,
    autoComplete: 'given-name',
  },
  {
    iconL: 'edit',
    name: 'lastname',
    placeholder: 'Apellido',
    required: true,
    autoComplete: 'family-name',
  },
  {
    iconL: 'user',
    name: 'document',
    placeholder: 'Documento',
    required: true,
    inputMode: 'numeric',
    autoComplete: 'username',
  },
  {
    iconL: 'title',
    name: 'email',
    placeholder: 'E-mail',
    required: false,
    autoComplete: 'email',
  },
]

export const ACTIVATE_FORM = [
  {
    iconL: 'edit',
    name: 'password',
    placeholder: 'Contraseña',
    type: 'password',
    required: true,
  },
  {
    iconL: 'edit',
    name: 'password2',
    placeholder: 'Repita la contraseña',
    type: 'password',
    required: true,
  },
]
